import { getDistance } from 'geolib';
import { getEpsilon } from './polyfills';

/**
 * Trie les points alphabetiquement.
 *
 * @param {[any]} pointsATrier La liste des points à trier alphabetiquement.
 * @param {string} propriete La propriété sur laquelle se baser pour trier la liste de points.
 * @returns Les points triés alphabetiquement.
 */
const trierParAlphabet = (pointsATrier, propriete) => {
    const points = [];
    const pointsTries = [];

    pointsATrier.map((value) => {
        points.push([value, value[propriete]]);
    });

    points.sort((a, b) => {
        return a[1].localeCompare(b[1]);
    });

    points.forEach((item) => {
        pointsTries.push(item[0]);
    });

    return pointsTries;
};

/**
 * Trie les points en fonction de leur distance à l'utilisateur.
 *
 * @param {[any]} pointsATrier La liste des points à trier par distance.
 * @param {{lat: number, lng: number}}
 * @returns Les points triés par distance.
 */
const trierParDistance = (pointsATrier, { lat, lng }) => {
    const points = [];
    const pointsTries = [];
    const coords = { lat, lng };

    pointsATrier.map((value) => {
        points.push([
            value,
            distanceEntre({ lat: coords.lat, lng: coords.lng }, { lat: value.latitude, lng: value.longitude }),
        ]);
    });

    points.sort((a, b) => {
        return a[1] - b[1];
    });

    points.forEach((item) => {
        pointsTries.push(item[0]);
    });

    return pointsTries;
};

/**
 * Calcule la distance entre deux jeux de coordonnées.
 *
 * @param {{lat: number, lng: number}} from Les coordonnées du point de départ.
 * @param {{lat: number, lng: number}} to Les coordonnées du point d'arrivée.
 * @returns La distance entre les deux jeux de coordonnées.
 */
const distanceEntre = (from, to) => {
    const fromCoord = { latitude: from.lat, longitude: from.lng };
    const toCoord = { latitude: to.lat, longitude: to.lng };
    const distance = getDistance(fromCoord, toCoord, 1) / 1000;

    return Math.round((distance + getEpsilon()) * 100) / 100;
};

export { trierParAlphabet, trierParDistance, distanceEntre };
